// The twelve month names, in Hebrew and English.
//
// One source instead of a copy per component. Two shapes are consumed today:
// `monthName` / `formatMonthYear` resolve a SINGLE name for a period badge or
// a "March 2026" label (the KPI strips InterventionMetrics and BIMetrics, and
// the analytics PDF export's getFilterLabel), while `monthNamesFor` hands back
// the whole list in the active language for the month dropdowns on the
// customer-facing analytics, BI and interventions pages (the /analytics
// RangeControl, BIFilters, InterventionFilters) - so no caller has to know
// the "he" / "en" key convention.
//
// Anything rendering a month name belongs here. Do not restate the strings in
// a component: they are user-facing copy and every wording change is approved
// by the owner, which only works while there is one place to change.

export const MONTH_NAMES = {
  en: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  he: [
    "ינואר",
    "פברואר",
    "מרץ",
    "אפריל",
    "מאי",
    "יוני",
    "יולי",
    "אוגוסט",
    "ספטמבר",
    "אוקטובר",
    "נובמבר",
    "דצמבר",
  ],
};

/**
 * All twelve names in the active language, January first.
 * The returned array is the shared module-level one - treat it as read-only.
 */
export const monthNamesFor = (isHebrew) => MONTH_NAMES[isHebrew ? "he" : "en"];

/**
 * Name of a 1-12 month in the active language.
 * Returns "" for anything outside 1-12 so a caller cannot render `undefined`.
 */
export const monthName = (month, isHebrew) => monthNamesFor(isHebrew)[month - 1] || "";

/** "March 2026" / "מרץ 2026". */
export const formatMonthYear = (month, year, isHebrew) =>
  `${monthName(month, isHebrew)} ${year}`;
